import React from "react";
import LandingShell from "@/components/landing/LandingShell";
import { ProfilePanel } from "@/pages/Profile";

export default function WebProfile() {
  return (
    <LandingShell showSectionLinks={false}>
      <div className="mx-auto w-full max-w-7xl px-6 py-10 md:py-14">
        <div className="rounded-2xl bg-card p-6 shadow-card md:p-10">
          <ProfilePanel embedded />
        </div>
      </div>
    </LandingShell>
  );
}
